//export const BASE_URL='http://localhost:55602/srtestapi';
export const BASE_URL='https://mocktestapi.shubhraranjan.com/api/v1/mocktest/srtestapi';
export const AuthToken='qaw8AxBFDXzJLbhMJyTOmkoFGLlagVUY';
